import {
  Box,
  Table,
  TableContainer,
  Tbody,
  Thead,
  Tr,
  Th,
  Flex,
  Skeleton,
  VStack,
  HStack,
  Text,
  Heading,
  IconButton,
} from "@chakra-ui/react";
import React from "react";
import { useDeleteDepartment } from "../../services/configurationService";
import { FiEdit, FiTrash2 } from "react-icons/fi";

const DepartmentTable = ({ configurationData = [], handleEdit, config, refetchGetDepartment, getDepartmentIsLoading }) => {
  const { deleteDepartmentPayload } = useDeleteDepartment((res) => refetchGetDepartment());

  const handleDelete = (id) => {
    deleteDepartmentPayload(id);
  };

  if (getDepartmentIsLoading) {
    return (
      <Box p={6}>
        <TableContainer>
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>ID</Th>
                <Th>Department</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {[1, 2, 3, 4, 5].map((i) => (
                <Tr key={i}>
                  <Th><Skeleton height="20px" /></Th>
                  <Th><Skeleton height="20px" /></Th>
                  <Th><Skeleton height="20px" /></Th>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  if (!getDepartmentIsLoading && !configurationData?.length) {
    return (
      <Box p={8} textAlign="center">
        <VStack spacing={4}>
          <Box
            p={4}
            borderRadius="50%"
            bg="gray.100"
            color="gray.500"
            fontSize="2xl"
          >
            🏢
          </Box>
          <VStack spacing={2}>
            <Text fontSize="lg" fontWeight="600" color="gray.700">
              No Departments Found
            </Text>
            <Text color="gray.500" fontSize="sm">
              No department records found. Add your first department to get started.
            </Text>
          </VStack>
        </VStack>
      </Box>
    );
  }

  return (
    <Box>
      {/* Table Header */}
      <Flex 
        justifyContent="space-between" 
        alignItems="center" 
        p={6} 
        borderBottom="1px solid" 
        borderColor="gray.200"
        bg="white"
      >
        <VStack align="start" spacing={1}>
          <Heading size="md" color="gray.900" fontWeight="600">
            Department Directory
          </Heading>
          <Text color="gray.600" fontSize="sm">
            {configurationData?.length || 0} departments
          </Text>
        </VStack>
      </Flex>

      {/* Department Table */}
      <TableContainer>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>ID</Th>
              <Th>Department</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {configurationData?.map((item) => (
              <DepartmentTableRow
                key={item?.id}
                id={item?.id}
                name={item?.name}
                onEdit={() => handleEdit(item)}
                onDelete={() => handleDelete(item?.id)}
              />
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

// Department Table Row Component
const DepartmentTableRow = ({ id, name, onEdit, onDelete }) => {
  return (
    <Tr _hover={{ bg: "gray.50" }}>
      <Th>{id}</Th>
      <Th>{name}</Th>
      <Th>
        <HStack spacing={2} justify="center">
          <IconButton
            icon={<FiEdit />}
            variant="ghost"
            size="sm"
            aria-label="Edit department"
            onClick={onEdit}
            color="green.500"
            _hover={{ bg: "green.50" }}
          />
          <IconButton
            icon={<FiTrash2 />}
            variant="ghost"
            size="sm"
            aria-label="Delete department"
            onClick={onDelete}
            color="red.500"
            _hover={{ bg: "red.50" }}
          />
        </HStack>
      </Th>
    </Tr>
  );
};

export default DepartmentTable;
